//@flow
import React from "react";
import { Text, TouchableOpacity, Dimensions, View } from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import theme from "app/Theme/Theme";

const { width, height } = Dimensions.get("window");
const aspectRatio = height / width;
const isPad = () => aspectRatio < 1.6;

type Props = {
  onPress: () => mixed,
  text: string,
  testID: string,
  disable: false,
  buttonPropStyle?: {},
  textPropStyle?: {},
};

const LightButton = ({
  testID,
  disable,
  onPress,
  text,
  buttonPropStyle,
  textPropStyle,
}: Props) => {
  let { buttonStyle, textStyle } = styles;
  buttonStyle = buttonPropStyle
    ? { ...buttonStyle, ...buttonPropStyle }
    : buttonStyle;
  textStyle = textPropStyle ? { ...textStyle, ...textPropStyle } : textStyle;

  const result = !disable ? (
    <TouchableOpacity onPress={onPress} style={buttonStyle} testID={testID}>
      <Text style={textStyle}>{text}</Text>
    </TouchableOpacity>
  ) : (
    <View style={buttonStyle} testID={testID}>
      <Text style={textStyle}>{text}</Text>
    </View>
  );
  return result;
};

const styles = {
  textStyle: {
    alignSelf: "center",
    color: theme.colors["brand.500"],
    fontSize: wp("4%"),
    fontWeight: "normal",
    padding: 10,
  },
  buttonStyle: {
    width: wp("75%"),
    height: wp("4%"),
    minHeight: isPad() ? hp("8%") : 45,
    alignItems: "center",
    justifyContent: "center",
    borderColor: theme.colors["brand.500"],
    borderWidth: 1,
    borderRadius: 10,
    marginLeft: 5,
    marginRight: 5,
  },
};

export { LightButton };
